const styles = {
  container: 'py-36 sm:py-56',
  content: 'flex flex-col gap-y-4',

  head: '',

  title: 'text-8xl opacity-5 text-center',
  description: 'text-3xl text-center mt-4',

  button: {
    container: 'text-center underline mt-4',
    label: 'text-xl font-bold',
  },
};

export default styles;
